// extracted by mini-css-extract-plugin
export default {"card":"ExtensionCard_card__0MXVZ","icon":"ExtensionCard_icon__faAtZ","title":"ExtensionCard_title__lwntZ"};